<template>
  <div>
    <v-flex style="border-bottom: 1px solid black">
      <v-flex xs12>
        <h3 class="title px-2 py-3" style="text-decoration: underline">
          Previous School Attended
        </h3>
      </v-flex>
      <v-flex xs12 md px-1 mt-3>
        <v-layout column align-content-center justify-center fill-height>
          <v-layout row wrap>
            <v-flex>
              <v-text-field
                required
                name="previous_school_name"
                label="Last school attended"
                box
                :rules="validationRules"
                v-model="previous_school_name"
              ></v-text-field>
              <v-text-field
                name="previous_school_address"
                label="Last school's address"
                box
                :rules="validationRules"
                v-model="previous_school_address"
              ></v-text-field>
              <v-text-field
                name="previous_school_dates"
                label="Dates attended last school"
                box
                :rules="validationRules"
                v-model="previous_school_dates"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex mt-4>
              <h4>Type:</h4>
            </v-flex>
            <v-flex xs12 md8 px-1>
              <v-radio-group
                v-model="previous_school_type"
                row
                :mandatory="true"
                :rules="validationRules"
                :class="{
                  'radio-group-spacing': $vuetify.breakpoint.smAndDown,
                }"
              >
                <v-radio label="Public" value="public"></v-radio>
                <v-radio label="Private" value="private"></v-radio>
                <v-radio label="Charter" value="charter"></v-radio>
                <v-radio label="Alternative" value="alternative"></v-radio>
                <v-radio
                  label="Correctional Facility"
                  value="correctional_facility"
                ></v-radio>
                <v-radio label="Other" value="other"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 md3 px-1>
              <v-text-field
                :rules="
                  is_previous_school_type_other ? validationRules : noRules
                "
                :disabled="!is_previous_school_type_other"
                name="previous_school_type_other_field"
                label="Other"
                box
                v-model="previous_school_type_other_field"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 md12 px-1>
              <v-layout row wrap>
                <v-flex xs12
                  >Has this student ever attended Mesa Public Schools?</v-flex
                >
                <v-flex xs12 md2 lg2 pr-2>
                  <v-select
                    name="is_previous_student_of_mpsaz"
                    :items="booleans"
                    :rules="everAttendedMPSRules"
                    box
                    v-model="is_previous_student_of_mpsaz"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md10 lg10>
                  <v-text-field
                    name="previous_grade_and_year"
                    label="If yes, grade(s) and year(s):"
                    :disabled="is_previous_student_of_mpsaz ? false : true"
                    box
                    v-model="previous_grade_and_year"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-flex>
    <v-flex style="border-bottom: 1px solid black">
      <v-flex xs12>
        <h3 class="title px-2 py-4" style="text-decoration: underline">
          ADDITIONAL INFORMATION
        </h3>
        <v-flex px-2>
          <h4 class="biggly">Students with Disabilities</h4>
          <p>
            You may want to discuss what supports your child may need to have an
            equal opportunity to continue to participate at Eagleridge as a
            child with a disability under Section 504 of the Rehabilitation Act
            and the Americans With Disabilities Act (ADA).
          </p>
        </v-flex>
        <v-flex px-2>
          <p>
            Eagleridge does not provide students a free appropriate public
            education (FAPE) pursuant to the Individuals with Disabilities
            Education Act (IDEA) because all students are homeschooled by their
            parents. If your child is qualified to receive special education
            services under IDEA, you have several options:
          </p>
          <ul>
            <li>
              If you reside within the boundaries of MPS, your child may be
              entitled to limited special education services through a “service
              plan” if he/she does not already have such a plan.
            </li>
            <br />
            <li>
              If you reside within the boundaries of MPS, you may choose to
              enroll your child at a school in the District. In this case, MPS
              will be responsible for providing your child with FAPE, which
              means that your child will receive special education and related
              services in accordance with his/her IEP.
              <br />You may obtain information about either of these options
              from the MPS Special Education Department at (480) 472-0710.
              <br />
            </li>

            <br />
            <li>
              If you reside within the boundaries of a school district other
              than MPS, you may choose to contact that school district to learn
              more about its special education programs or the availability of a
              service plan.
            </li>
            <br />
            <li>
              If your child is a recipient of the Empowerment Scholarship
              Account (ESA), or if you're seeking approval for ESA, let us know
              at the time of registration.
              <ul>
                <li>
                  Read and submit a signed copy of the
                  <a
                    href="https://docs.google.com/document/d/1ujkhsgLQtWVsC7owEYlaXIsKZrndGj-vxu-66wo9Ul4/edit?usp=sharing"
                    target="_blank"
                    >Eagleridge ESA Guidelines and tuition rates</a
                  >.
                </li>
                <li>
                  Submit a copy of your ESA contract to:
                  <a href="mailto:eagleridge-reply@mpsaz.org" target="_blank"
                    >eagleridge-reply@mpsaz.org</a
                  >.
                </li>
              </ul>
            </li>
            <br />
          </ul>
        </v-flex>
        <v-flex py-3>
          <v-checkbox
            name="has_read_SDS"
            v-model="has_read_SDS"
            label="I have read the Students with Disabilities section above."
            :rules="checkBoxRules"
            required
          ></v-checkbox>
        </v-flex>
      </v-flex>

      <v-flex xs12 md px-1 mt-3>
        <v-layout column align-content-center justify-center fill-height>
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-layout row wrap>
                <v-flex xs12
                  >Has this student ever participated in special classes or
                  programs?</v-flex
                >
                <v-flex xs12 md2 lg2>
                  <v-select
                    name="has_been_in_special_classes"
                    :items="booleans"
                    :rules="beenInSpecialClassesRule"
                    box
                    v-model="has_been_in_special_classes"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-flex v-if="has_been_in_special_classes === true">
                <v-layout>
                  <p>Please check the appropriate box(es) below.</p>
                </v-layout>
                <v-flex>
                  <v-layout row wrap>
                    <v-checkbox
                      v-model="special_classes"
                      :rules="[() => rules.atLeastOneClass(special_classes)]"
                      label="SEI/English Language Development"
                      value="SEI/English Language Development"
                      :hide-details="true"
                    ></v-checkbox>
                  </v-layout>
                  <v-layout row wrap>
                    <v-checkbox
                      v-model="special_classes"
                      :rules="[() => rules.atLeastOneClass(special_classes)]"
                      label="Band"
                      value="Band"
                      :hide-details="true"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="special_classes"
                      :rules="[() => rules.atLeastOneClass(special_classes)]"
                      label="Strings"
                      value="Strings"
                      :hide-details="true"
                    ></v-checkbox>
                  </v-layout>
                  <v-layout row wrap>
                    <v-checkbox
                      v-model="special_classes"
                      :rules="[() => rules.atLeastOneClass(special_classes)]"
                      label="Speech Therapy"
                      value="Speech Therapy"
                      :hide-details="true"
                    ></v-checkbox>
                  </v-layout>
                  <v-layout row wrap>
                    <v-checkbox
                      v-model="special_classes"
                      :rules="[() => rules.atLeastOneClass(special_classes)]"
                      label="Extended Learning Program (ELP)/Gifted/Accelerated"
                      value="Extended Learning Program (ELP)/Gifted/Accelerated"
                    ></v-checkbox>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12
                      >Has this student ever participated in Special
                      Education?</v-flex
                    >
                    <v-flex xs12 md2 lg2 pr-2>
                      <v-select
                        name="has_been_in_special_ed"
                        :items="booleans"
                        :rules="beenInSpecialEdRule"
                        box
                        v-model="has_been_in_special_ed"
                      ></v-select>
                    </v-flex>
                    <v-layout roe wrap v-if="has_been_in_special_ed === true">
                      <v-checkbox
                        v-model="selected_special_ED"
                        label="ED"
                        value="ED"
                        :rules="[
                          () => rules.atLeastOneSpecialEd(selected_special_ED),
                        ]"
                        :hide-details="false"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="selected_special_ED"
                        label="Autism"
                        value="Autism"
                        :rules="[
                          () => rules.atLeastOneSpecialEd(selected_special_ED),
                        ]"
                        :hide-details="true"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="selected_special_ED"
                        label="SLD"
                        value="SLD"
                        :rules="[
                          () => rules.atLeastOneSpecialEd(selected_special_ED),
                        ]"
                        :hide-details="true"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="selected_special_ED"
                        label="MIID"
                        value="MIID"
                        :rules="[
                          () => rules.atLeastOneSpecialEd(selected_special_ED),
                        ]"
                        :hide-details="true"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="selected_special_ED"
                        label="MOID"
                        value="MOID"
                        :rules="[
                          () => rules.atLeastOneSpecialEd(selected_special_ED),
                        ]"
                        :hide-details="true"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="selected_special_ED"
                        label="SID"
                        value="SID"
                        :rules="[
                          () => rules.atLeastOneSpecialEd(selected_special_ED),
                        ]"
                        :hide-details="true"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="selected_special_ED"
                        label="OT"
                        value="OT"
                        :rules="[
                          () => rules.atLeastOneSpecialEd(selected_special_ED),
                        ]"
                        :hide-details="true"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="selected_special_ED"
                        label="SLI"
                        value="SLI"
                        :rules="[
                          () => rules.atLeastOneSpecialEd(selected_special_ED),
                        ]"
                        :hide-details="true"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="selected_special_ED"
                        label="Other"
                        value="Other"
                        :rules="[
                          () => rules.atLeastOneSpecialEd(selected_special_ED),
                        ]"
                        :hide-details="true"
                      ></v-checkbox>
                      <v-flex xs12 md4 lg4>
                        <v-text-field
                          :rules="
                            is_special_ED_other ? validationRules : noRules
                          "
                          name="other_special_ED_classes"
                          label="Other"
                          :disabled="!is_special_ED_other"
                          box
                          v-model="other_special_ED_classes"
                        ></v-text-field>
                      </v-flex>
                      <v-layout row wrap>
                        <v-layout row wrap>
                          <v-flex xs12
                            >Does this student have a current IEP?</v-flex
                          >
                          <v-flex xs12 md4 lg2>
                            <v-select
                              name="has_current_IEP"
                              :items="booleans"
                              :rules="booleanRule"
                              box
                              v-model="has_current_IEP"
                            ></v-select>
                          </v-flex>
                          <v-flex>
                            <v-label v-if="has_current_IEP"
                              >Please provide a copy of the IEP to the
                              office</v-label
                            >
                          </v-flex>
                        </v-layout>

                        <v-layout row wrap>
                          <v-flex xs12
                            >Does this student have a current MET
                            report?</v-flex
                          >
                          <v-flex xs12 md4 lg2>
                            <v-select
                              name="has_current_MET_report"
                              :items="booleans"
                              :rules="booleanRule"
                              box
                              v-model="has_current_MET_report"
                            ></v-select>
                          </v-flex>
                          <v-flex>
                            <v-label v-if="has_current_MET_report"
                              >Please provide a copy of the MET report to the
                              office</v-label
                            >
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-layout>
                  </v-layout>
                </v-flex>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
      <v-layout xs12 md px-1 row wrap>
        <v-flex xs12>Does this student have a current 504 plan?</v-flex>
        <v-flex xs12 md2 lg2>
          <v-select
            name="has_504_plan"
            :items="booleans"
            :rules="booleanRule"
            box
            v-model="has_504_plan"
          ></v-select>
        </v-flex>
        <v-flex>
          <v-label v-if="has_504_plan"
            >Please provide a copy of the 504 plan to the office</v-label
          >
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex style="border-bottom: 1px solid black">
      <v-flex xs12>
        <h3 class="title px-2 py-4" style="text-decoration: underline">
          Legal Documents
        </h3>
      </v-flex>
      <v-flex xs12 md px-1 mt-3>
        Please mark any items that apply to this student, and provide the school
        with copies of related court documents.
        <v-checkbox
          v-model="has_custody_agreement"
          label="Custody/parenting time agreement"
        ></v-checkbox>
        <v-checkbox
          v-model="has_letters_of_guardianship"
          label="Letters of guardianship for court-appointed guardian"
        ></v-checkbox>
        <v-checkbox
          v-model="has_power_of_attorney"
          label="Power of Attorney"
        ></v-checkbox>
        <v-checkbox
          v-model="is_not_living_with_bio_parents"
          label="Student is not living with his/her biological parents"
        ></v-checkbox>
        <v-checkbox
          v-model="has_injunction"
          label="Student has an injunction against harassment against/from another person"
        ></v-checkbox>
        <v-checkbox
          v-model="has_order_of_protection"
          label="Student has an order of protection against/from another person"
        ></v-checkbox>
        <v-checkbox
          v-model="is_covered_by_order"
          label="Student is covered by a court or probation order"
        ></v-checkbox>
      </v-flex>
    </v-flex>
    <v-flex style="border-bottom: 1px solid black">
      <v-flex xs12>
        <h3 class="title px-2 py-4" style="text-decoration: underline">
          Suspension/Expulsion Discipline Information
        </h3>
      </v-flex>
      <v-layout row wrap>
        <v-flex xs12>Has this student ever been suspended from school?</v-flex>
        <v-flex xs12 md2 lg2 pr-2>
          <v-select
            name="has_been_suspended"
            :rules="booleanRule"
            :items="booleans"
            box
            v-model="has_been_suspended"
          ></v-select>
        </v-flex>
        <v-flex>
          <v-text-field
            v-if="has_been_suspended"
            name="suspended_dates"
            label="Date(s) suspended:"
            :rules="validationRules"
            box
            v-model="suspended_dates"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>Has this student ever been expelled from school?</v-flex>
        <v-flex xs12 md2 lg2 pr-2>
          <v-select
            name="has_been_expelled"
            :rules="booleanRule"
            :items="booleans"
            box
            v-model="has_been_expelled"
          ></v-select>
        </v-flex>
        <v-flex>
          <v-text-field
            v-if="has_been_expelled"
            name="expulsion_dates"
            label="Date(s) expelled:"
            box
            :rules="validationRules"
            v-model="expulsion_dates"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12
          >Has either action ever been recommended for this student?</v-flex
        >
        <v-flex xs12 md2 lg2 pr-2>
          <v-select
            name="has_suspension_or_expulsion_been_recommended"
            :items="booleans"
            :rules="booleanRule"
            box
            v-model="has_suspension_or_expulsion_been_recommended"
          ></v-select>
        </v-flex>
        <v-flex>
          <v-text-field
            v-if="has_suspension_or_expulsion_been_recommended"
            name="recommendation_dates"
            label="Date(s) the suspension/expulsion was recommended:"
            :rules="validationRules"
            box
            v-model="recommendation_dates"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        v-if="
          has_been_suspended ||
          has_been_expelled ||
          has_suspension_or_expulsion_been_recommended
        "
      >
        <v-flex xs12>From which school?</v-flex>
        <v-flex xs12 md12 lg12 pr-2>
          <v-text-field
            name="school_suspended_or_expelled_from"
            label="From which school?"
            :rules="validationRules"
            box
            v-model="school_suspended_or_expelled_from"
          ></v-text-field>
        </v-flex>
        <v-flex v-if="has_been_suspended || has_been_expelled">
          <v-flex>Length of suspension/expulsion:</v-flex>
          <v-flex>
            <v-radio-group
              v-model="length_of_expulsion_suspension"
              row
              :rules="
                has_been_suspended ||
                has_been_expelled ||
                has_suspension_or_expulsion_been_recommended
                  ? validationRules
                  : noRules
              "
              :class="{ 'radio-group-spacing': $vuetify.breakpoint.smAndDown }"
            >
              <v-radio label="1-5 days" value="1-5 days"></v-radio>
              <v-radio label="6-10 days" value="6-10 days"></v-radio>
              <v-radio
                label="More than 10 days"
                value="More than 10 days"
              ></v-radio>
            </v-radio-group>
            <v-text-field
              v-if="length_of_expulsion_suspension == 'More than 10 days'"
              :rules="validationRules"
              name="specific_number_of_days"
              label="Specify if more than 10 days"
              box
              v-model="specific_number_of_days"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
              name="reason_for_suspension_expulsion"
              label="Reason for suspension/expulsion:"
              :rules="validationRules"
              box
              v-model="reason_for_suspension_expulsion"
            ></v-text-field>
          </v-flex>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12
          >If on open enrollment at another Mesa school, was it revoked?</v-flex
        >
        <v-flex xs12 md2 lg2 pr-2>
          <v-select
            name="has_been_revoked"
            :rules="booleanRule"
            :items="booleans"
            box
            v-model="has_been_revoked"
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12
          >Has this student ever attended school at a correctional
          facility?</v-flex
        >
        <v-flex xs12 md2 lg2 pr-2>
          <v-select
            name="has_ever_been_in_correctional_facility"
            :items="booleans"
            :rules="booleanRule"
            box
            v-model="has_ever_been_in_correctional_facility"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex style="border-bottom: 1px solid black">
      <v-flex xs12>
        <h3 class="title px-2 py-4" style="text-decoration: underline">
          Other
        </h3>
      </v-flex>

      <v-flex>
        <v-flex>Transportation to and from school will be:</v-flex>
        <v-layout
          :column="$vuetify.breakpoint.smAndDown ? true : false"
          :row="$vuetify.breakpoint.md ? true : false"
        >
          <v-checkbox
            :rules="[
              () => rules.atLeastOneTransportation(selected_transportation),
            ]"
            v-model="selected_transportation"
            label="Bus"
            value="Bus"
            :hide-details="$vuetify.breakpoint.smAndDown"
          ></v-checkbox>
          <v-checkbox
            :rules="[
              () => rules.atLeastOneTransportation(selected_transportation),
            ]"
            v-model="selected_transportation"
            label="Walking"
            value="Walking"
            :hide-details="true"
          ></v-checkbox>
          <v-checkbox
            :rules="[
              () => rules.atLeastOneTransportation(selected_transportation),
            ]"
            v-model="selected_transportation"
            label="Parent will transport"
            value="Parent will transport"
            :hide-details="true"
          ></v-checkbox>
          <v-checkbox
            :rules="[
              () => rules.atLeastOneTransportation(selected_transportation),
            ]"
            v-model="selected_transportation"
            label="Daycare van"
            value="Daycare van"
            :hide-details="true"
          ></v-checkbox>
          <v-checkbox
            :rules="[
              () => rules.atLeastOneTransportation(selected_transportation),
            ]"
            v-model="selected_transportation"
            label="Other"
            value="Other"
            :hide-details="!$vuetify.breakpoint.smAndDown"
          ></v-checkbox>
          <br />
          <v-flex xs12 md4 lg4>
            <v-text-field
              :rules="is_transportation_other ? validationRules : noRules"
              name="transportation_type"
              label="Other"
              :disabled="!is_transportation_other"
              box
              v-model="transportation_type"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-layout row wrap>
        <v-flex xs12
          >Would you like information about the free or reduced-price lunch
          program?</v-flex
        >
        <v-flex xs12 md2 lg2 pr-2>
          <v-select
            name="is_wanting_info_about_lunch_program"
            :items="booleans"
            :rules="booleanRule"
            box
            v-model="is_wanting_info_about_lunch_program"
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>Are you an American Indian?</v-flex>
        <v-flex xs12 md2 lg2 pr-2>
          <v-select
            name="is_american_indian"
            :rules="booleanRule"
            :items="booleans"
            box
            v-model="is_american_indian"
          ></v-select>
        </v-flex>

        <v-layout row wrap v-if="is_american_indian">
          <v-flex mt-4>
            <p>What community do you live in:</p>
          </v-flex>
          <v-radio-group
            v-model="lives_in"
            row
            :rules="validationRules"
            :class="{ 'radio-group-spacing': $vuetify.breakpoint.smAndDown }"
          >
            <v-radio label="Salt River" value="Salt River"></v-radio>
            <v-radio label="Ft. McDowell" value="Ft. McDowell"></v-radio>
            <v-radio label="Mesa (in-town)" value="Mesa (in-town)"></v-radio>
          </v-radio-group>
          <v-flex>
            <v-text-field
              name="US_tribal_number"
              label="US tribal number?"
              box
              :rules="validationRules"
              v-model="US_tribal_number"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      booleans: [
        {
          text: "Yes",
          value: true,
        },
        {
          text: "No",
          value: false,
        },
      ],
      rules: {
        atLeastOneTransportation: (selected) =>
          selected.length > 0 || "Required",

        atLeastOneClass: (selected) =>
          selected.length > 0 || "Please select at least one class",

        atLeastOneSpecialEd: (selected) => selected.length > 0 || "Required",
      },

      validationRules: [(v) => !!v || "Field is required"],
      noRules: [],
      checkBoxRules: [(v) => !!v || "You must click the checkbox to continue"],
      everAttendedMPSRules: [
        (v) => v === true || v === false || "Field is required",
      ],
      beenInSpecialClassesRule: [
        (v) => v === true || v === false || "Field is required",
      ],
      beenInSpecialEdRule: [
        (v) => v === true || v === false || "Field is required",
      ],
      booleanRule: [(v) => v === true || v === false || "Field is required"],
    };
  },
  computed: {
    is_transportation_other() {
      return this.$store.state.registration.partCInfo.selected_transportation.includes(
        "Other"
      );
    },
    is_previous_school_type_other() {
      return (
        this.$store.state.registration.partCInfo.previous_school_type ===
        "other"
      );
    },
    previous_school_name: {
      get() {
        return this.$store.state.registration.partCInfo.previous_school_name;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setPreviousSchoolName",
          value
        );
      },
    },
    previous_school_address: {
      get() {
        return this.$store.state.registration.partCInfo.previous_school_address;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setPreviousSchoolAddress",
          value
        );
      },
    },
    previous_school_dates: {
      get() {
        return this.$store.state.registration.partCInfo.previous_school_dates;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setPreviousSchoolDates",
          value
        );
      },
    },
    previous_school_type_other_field: {
      get() {
        return this.$store.state.registration.partCInfo
          .previous_school_type_other_field;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setPreviousSchoolTypeOtherField",
          value
        );
      },
    },
    previous_school_type: {
      get() {
        return this.$store.state.registration.partCInfo.previous_school_type;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setPreviousSchoolType",
          value
        );
      },
    },
    is_previous_student_of_mpsaz: {
      get() {
        return this.$store.state.registration.partCInfo
          .is_previous_student_of_mpsaz;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setPreviousStudentOfMPSAZ",
          value
        );
      },
    },
    previous_grade_and_year: {
      get() {
        return this.$store.state.registration.partCInfo.previous_grade_and_year;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setPreviousGradeAndYear",
          value
        );
      },
    },
    has_read_SDS: {
      // SDS is short for  Section
      get() {
        return this.$store.state.registration.partCInfo.has_read_SDS;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasReadSDS", value);
      },
    },
    has_been_in_special_classes: {
      get() {
        return this.$store.state.registration.partCInfo
          .has_been_in_special_classes;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setHasBeenInSpecialClasses",
          value
        );
      },
    },
    special_classes: {
      get() {
        return this.$store.state.registration.partCInfo.special_classes;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setSpecialClasses", value);
      },
    },
    has_been_in_special_ed: {
      get() {
        return this.$store.state.registration.partCInfo.has_been_in_special_ed;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setHasBeenInSpecial_Ed",
          value
        );
      },
    },
    has_been_in_ED: {
      get() {
        return this.$store.state.registration.partCInfo.has_been_in_ED;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasBeenInED", value);
      },
    },
    has_been_in_autism_classes: {
      get() {
        return this.$store.state.registration.partCInfo
          .has_been_in_autism_classes;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setHasBeenInAutismClasses",
          value
        );
      },
    },
    has_been_in_SLD: {
      get() {
        return this.$store.state.registration.partCInfo.has_been_in_SLD;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasBeenInSLD", value);
      },
    },
    has_been_in_MIID: {
      get() {
        return this.$store.state.registration.partCInfo.has_been_in_MIID;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasBeenInMIID", value);
      },
    },
    has_been_in_MOID: {
      get() {
        return this.$store.state.registration.partCInfo.has_been_in_MOID;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasBeenInMOID", value);
      },
    },
    has_been_in_SID: {
      get() {
        return this.$store.state.registration.partCInfo.has_been_in_SID;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasBeenInSID", value);
      },
    },
    has_been_in_OT: {
      get() {
        return this.$store.state.registration.partCInfo.has_been_in_OT;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasBeenInOT", value);
      },
    },
    has_been_in_SLI: {
      get() {
        return this.$store.state.registration.partCInfo.has_been_in_SLI;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasBeenInSLI", value);
      },
    },
    is_special_ED_other() {
      return this.$store.state.registration.partCInfo.selected_special_ED.includes(
        "Other"
      );
    },
    other_special_ED_classes: {
      get() {
        return this.$store.state.registration.partCInfo
          .other_special_ED_classes;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setOtherSpecialEdClasses",
          value
        );
      },
    },
    has_current_IEP: {
      get() {
        return this.$store.state.registration.partCInfo.has_current_IEP;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasCurrentIEP", value);
      },
    },
    has_current_MET_report: {
      get() {
        return this.$store.state.registration.partCInfo.has_current_MET_report;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasCurrentMET", value);
      },
    },
    has_504_plan: {
      get() {
        return this.$store.state.registration.partCInfo.has_504_plan;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasCurrent504", value);
      },
    },
    has_custody_agreement: {
      get() {
        return this.$store.state.registration.partCInfo.has_custody_agreement;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setHasCustodyAgreement",
          value
        );
      },
    },
    has_letters_of_guardianship: {
      get() {
        return this.$store.state.registration.partCInfo
          .has_letters_of_guardianship;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setHasLettersOfGuardianship",
          value
        );
      },
    },
    has_power_of_attorney: {
      get() {
        return this.$store.state.registration.partCInfo.has_power_of_attorney;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setHasPowerOfAttorney",
          value
        );
      },
    },
    is_not_living_with_bio_parents: {
      get() {
        return this.$store.state.registration.partCInfo
          .is_not_living_with_bio_parents;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setIsNotLivingWithBioParents",
          value
        );
      },
    },
    has_injunction: {
      get() {
        return this.$store.state.registration.partCInfo.has_injunction;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasInjunction", value);
      },
    },
    has_order_of_protection: {
      get() {
        return this.$store.state.registration.partCInfo.has_order_of_protection;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setHasOrderOfProtection",
          value
        );
      },
    },
    is_covered_by_order: {
      get() {
        return this.$store.state.registration.partCInfo.is_covered_by_order;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setIsCoveredByOrder", value);
      },
    },
    has_been_suspended: {
      get() {
        return this.$store.state.registration.partCInfo.has_been_suspended;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasBeenSuspended", value);
      },
    },
    suspended_dates: {
      get() {
        return this.$store.state.registration.partCInfo.suspended_dates;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setSuspendedDates", value);
      },
    },
    has_been_expelled: {
      get() {
        return this.$store.state.registration.partCInfo.has_been_expelled;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasBeenExpelled", value);
      },
    },
    expulsion_dates: {
      get() {
        return this.$store.state.registration.partCInfo.expulsion_dates;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setExpulsionDates", value);
      },
    },
    has_suspension_or_expulsion_been_recommended: {
      get() {
        return this.$store.state.registration.partCInfo
          .has_suspension_or_expulsion_been_recommended;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setHasSuspensionExpulsionBeenRecommended",
          value
        );
      },
    },
    recommendation_dates: {
      get() {
        return this.$store.state.registration.partCInfo.recommendation_dates;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setRecommendationDates",
          value
        );
      },
    },
    school_suspended_or_expelled_from: {
      get() {
        return this.$store.state.registration.partCInfo
          .school_suspended_or_expelled_from;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setSchoolSuspendedOrExpelledFrom",
          value
        );
      },
    },
    length_of_expulsion_suspension: {
      get() {
        return this.$store.state.registration.partCInfo
          .length_of_expulsion_suspension;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setLengthOfSuspension",
          value
        );
      },
    },
    specific_number_of_days: {
      get() {
        return this.$store.state.registration.partCInfo.specific_number_of_days;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setSpecificNumberOfDays",
          value
        );
      },
    },
    reason_for_suspension_expulsion: {
      get() {
        return this.$store.state.registration.partCInfo
          .reason_for_suspension_expulsion;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setReasonForSuspensionExpulsion",
          value
        );
      },
    },
    has_been_revoked: {
      get() {
        return this.$store.state.registration.partCInfo.has_been_revoked;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setHasBeenRevoked", value);
      },
    },
    has_ever_been_in_correctional_facility: {
      get() {
        return this.$store.state.registration.partCInfo
          .has_ever_been_in_correctional_facility;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setHasBeenInCorrectionalFacility",
          value
        );
      },
    },
    transportation_type: {
      get() {
        return this.$store.state.registration.partCInfo.transportation_type;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setTransportationType",
          value
        );
      },
    },
    is_wanting_info_about_lunch_program: {
      get() {
        return this.$store.state.registration.partCInfo
          .is_wanting_info_about_lunch_program;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setIsWantingInfoAboutLunchProgram",
          value
        );
      },
    },
    is_american_indian: {
      get() {
        return this.$store.state.registration.partCInfo.is_american_indian;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setIsAmericanIndian", value);
      },
    },
    lives_in: {
      get() {
        return this.$store.state.registration.partCInfo.lives_in;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setLivesIn", value);
      },
    },
    US_tribal_number: {
      get() {
        return this.$store.state.registration.partCInfo.US_tribal_number;
      },
      set(value) {
        this.$store.commit("registration/partCInfo/setUS_tribal_number", value);
      },
    },
    selected_transportation: {
      get() {
        return this.$store.state.registration.partCInfo.selected_transportation;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setSelectedTransportation",
          value
        );
      },
    },
    selected_special_ED: {
      get() {
        return this.$store.state.registration.partCInfo.selected_special_ED;
      },
      set(value) {
        this.$store.commit(
          "registration/partCInfo/setSelectedSpecialED",
          value
        );
      },
    },
  },
};
</script>

<style scoped>
.biggly {
  font-size: 20px;
}

a {
  margin-left: 0px;
}

li {
  font-size: 14px;
}
</style>
